/**
 * @fileoverview Footer component for the Storyteller web application.
 * Displays copyright information, navigation links, and logos of participating institutions.
 *
 * @example
 * // Basic usage
 * <Footer />
 */

import { useTranslation } from 'react-i18next'
import Harvard from './assets/Harvard.svg'
import JohnsHopkins from './assets/Johns Hopkins.svg'
import Mayo from './assets/Mayo.svg'
import Stanford from './assets/Stanford.svg'
import Yale from './assets/Yale.svg'

/**
 * @function Footer
 * @description Footer component for the Storyteller web application.
 * Displays copyright information, navigation links, and logos of participating institutions.
 *
 * @example
 * // Basic usage
 * <Footer />
 */
export function Footer() {
    const { t } = useTranslation()
    return (
        <footer className="footer">
            <div className="footer-left">
                <div className="copyright-container">
                    <span className="copyright">&copy; 2024 Novoic</span>
                </div>
                <div className="nav-group">
                    <a
                        className="nav-link"
                        href="https://help.novoic.com"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {t('footer.help.text')}
                    </a>
                    <a
                        href={t('footer.terms.link')}
                        target="_blank"
                        rel="noreferrer"
                        className="nav-link"
                    >
                        {t('footer.terms.text')}
                    </a>
                    <a
                        href={t('footer.privacy.link')}
                        target="_blank"
                        rel="noreferrer"
                        className="nav-link"
                    >
                        {t('footer.privacy.text')}
                    </a>
                </div>
            </div>
            <div>
                <div className="footer-center">
                    <div className="logos">
                        <Harvard />
                        <Yale />
                        <Mayo />
                        <Stanford />
                        <JohnsHopkins />
                    </div>
                    <p className="trust">{t('footer.promotion')}</p>
                </div>
            </div>
        </footer>
    )
}
